module.exports = __webpack_public_path__ + "img/_DSC6722.c95c1627.jpg";